import {
  Card, CardContent, CardHeader,
  CircularProgress, Paper, Container, colors,
  DialogActions, DialogTitle, DialogContent, Dialog, Slider, LinearProgress, Button, Input, Select, Option,
  Divider, Grid, CardActions, FormControl, InputAdornment, TextField, TableSortLabel, TablePagination, Slide,
  TableContainer, Table, TableHead, TableCell, TableRow, TableBody, CardMedia, Tabs, Tab, Backdrop, Typography, Snackbar
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import axios from "src/utils/axios";
import React, { useEffect, UseState } from 'react';
import Page from 'src/components/Page';
import ImageAcceptIcon from '@material-ui/icons/ThumbUp';
import ImageRejectIcon from '@material-ui/icons/ThumbDown';
import { getUser, CreateWareHouseAddress } from 'src/utils/Common';
import MuiAlert from '@material-ui/lab/Alert';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';
import AddressSearch from 'src/components/Selects/AddressSearch';
import SearchIcon from '@material-ui/icons/Search';
import MaterialDetail from 'src/components/MaterialDetail';



const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  }, backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const defaultUyari = { open: false, aciklama: '', tip: 'success' };






function PassOut() {
  const classes = useStyles();
  const [Loading, setLoading] = React.useState(false);
  const [dataPaslasma, setPaslasmaData] = React.useState([]);
  const [uyari, setUyari] = React.useState(defaultUyari);
  const [pagination, setPagination] = React.useState({ page: 0, rowsPerPage: 10 });
  const user = getUser();
  const [MaterialCodeParam, setMaterialCodeParam] = React.useState("");
  const [MaterialHeader, setMaterialHeader] = React.useState("");
  const [MaterialDetailPopup, setMaterialDetailPopup] = React.useState(false);

  const [passEditParam, setPassEditParam] = React.useState('');



  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(defaultUyari);
  };

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const GetOpenPassByService = () => {
    axios.get("GetOpenPassByService/3/" + user.ServiceShopId)
      .then(response => {
        // console.log(response);
        setPaslasmaData(response.data);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
  }

  useEffect(() => {
    CreateWareHouseAddress(user.ServiceShopId);
    GetOpenPassByService();
  }, []);

  function PassProcess(ISLEM_TIPI, ID, ADRES) {

    const _message = (ISLEM_TIPI === 1 ? 'Paslaşma talebi Onaylanacaktır. Devam etmek istediğinzden eminmisiniz?' : 'Paslaşma talebi red edilecektir. Devam etmek istediğinzden eminmisiniz?');



    confirmAlert({
      message: _message,
      buttons: [
        {
          label: 'Evet',
          onClick: () => PassProcessKabul(ISLEM_TIPI, ID, ADRES)
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  }




  function PassProcessKabul(ISLEM_TIPI, ID, ADRES) {
    setLoading(true);
    const data = {
      ISLEM_TIPI: ISLEM_TIPI,
      ID: ID,
      USERID: user.UserId,
      DEPO_ADRES_ID: ADRES
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetPassProcess', data, config)
      .then(response => {
        if (response.data.ErrorCode === "0") {
          setUyari({ open: true, aciklama: 'İşlem başarılı', tip: 'success' });
        } else {
          setUyari({ open: true, aciklama: response.data.ErrorDescription, tip: 'error' });
        }
        GetOpenPassByService();
        setLoading(false);
      }).catch(error => {
        setUyari({ open: true, aciklama: 'Bir hata oluştu!..' + error.message, tip: 'error' });
        setLoading(false);
      });

  }




  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');
  const [passEdit, setPassEdit] = React.useState(false);

  const GetPassEditPopUp = (event, ID) => {
    setPassEditParam(ID);
    setPassEdit(true);
  }
  const [KargoNovalue, setKargoNovalue] = React.useState();


  const handleKargoNoInputChange = (event) => {
    setKargoNovalue(event.target.value === '' ? '' : event.target.value);
  };


  const [GonderiTipvalue, setGonderiTipvalue] = React.useState(1);

  const handleGonderiTipInputChange = (event) => {
    setGonderiTipvalue(event.target.value === '' ? '' : Number(event.target.value));
  };

  function SetGonderimBilgisi() {
    const data = {
      GONDERIM_TIP: GonderiTipvalue,
      KARGO_NO: KargoNovalue,
      ID: passEditParam,
      USERID: user.UserId

    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetPassGonderimBilgisi', data, config)
      .then(response => {
        if (response.data.ErrorCode === "0") {
          setUyari({ open: true, aciklama: 'İşlem başarılı', tip: 'success' });
        } else {
          setUyari({ open: true, aciklama: response.data.ErrorDescription, tip: 'error' });
        }
        GetOpenPassByService();
        setLoading(false);
        setPassEdit(false);
      }).catch(error => {
        setUyari({ open: true, aciklama: 'Bir hata oluştu!..' + error.message, tip: 'error' });
        setLoading(false);
      });
  }

  const search = "";

  const setAdres = (param, index, MALZEME_STOK_NO) => {
    axios.get(`/GetAdresMalzemeKullanilabilirAdet/${user.ServiceShopId}/${param.Id}/${MALZEME_STOK_NO}`)
      .then(response => {
        let old_rows = [...dataPaslasma];
        old_rows[index].WarehouseAddress = param?.Id || 0;
        old_rows[index].WarehouseAddressText = param?.Description || 0;
        old_rows[index].Malzemeleri = param?.Materials || 0;
        old_rows[index].ADRES_ADET = response.data;
        setPaslasmaData(old_rows);
      })
      .catch(error => {
        console.log(error);
      });
  }

  const GetMaterialDetailPopup = (MaterialCode, Material) => {
    setMaterialCodeParam(MaterialCode);
    setMaterialHeader(MaterialCode + ' ' + Material);

    setMaterialDetailPopup(true);

  }

  return (
    <Page className={classes.root} title="oasis Yönetimi">
      <Container maxWidth="xl">
        <Card>
          <CardHeader title={' Sizden Onay Bekleyen Paslaşma Talepleri'}></CardHeader>
          <Backdrop className={classes.backdrop} open={Loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Divider />
          <Snackbar open={uyari.open} autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={uyariKapat}>
            <Alert onClose={uyariKapat} severity={uyari.tip}>
              {uyari.aciklama || ''}
            </Alert>
          </Snackbar>
          <CardContent>
            <TableContainer style={{ maxHeight: 700, minHeight: 700, }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Onay</TableCell>
                    <TableCell align="left">Red</TableCell>
                    <TableCell align="left">PaslaşmaNo</TableCell>
                    <TableCell align="left">Servis</TableCell>
                    <TableCell align="left">Adı</TableCell>
                    <TableCell align="left">Telefon</TableCell>
                    <TableCell align="left">AçıkAdres</TableCell>
                    <TableCell align="left">Tarih</TableCell>
                    <TableCell align="left">Durum</TableCell>
                    <TableCell align="left">MalzemeKodu</TableCell>
                    <TableCell align="left">Malzeme</TableCell>
                    <TableCell align="left">MalzemeDetay</TableCell>
                    <TableCell align="left">Adet</TableCell>
                    {/* <TableCell align="left">GönderiTip</TableCell>
                    <TableCell align="left">GönderiKodu</TableCell> */}
                    {/* <TableCell align="left">Adres</TableCell>
                    <TableCell align="left">AdresAdet</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataPaslasma.slice(pagination.page * pagination.rowsPerPage, (pagination.page + 1) * pagination.rowsPerPage).map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="left" className={classes.tableCell}>
                        {
                          row.ONAY_RED === 0 ? '' : <ImageAcceptIcon
                            onClick={() => PassProcess(1, row.ID, setAdres.Id)}
                            color="primary" />
                        }
                      </TableCell>
                      <TableCell align="left" className={classes.tableCell}>

                        {
                          row.ONAY_RED === 0 ? '' : <ImageRejectIcon
                            onClick={() => PassProcess(3, row.ID, setAdres.Id)}
                            color="error" />
                        }
                      </TableCell>
                      <TableCell align="left" >
                        {row.PASLASMA_NO}
                      </TableCell>
                      <TableCell align="left" >
                        {row.SERVIS}
                      </TableCell>
                      <TableCell align="left" >
                        {row.TALEP_EDEN}
                      </TableCell>
                      <TableCell align="left" >
                        {row.TELEFON}
                      </TableCell>
                      <TableCell align="left" >
                        {row.ACIK_ADRES}
                      </TableCell>
                      <TableCell align="left" >
                        {row.TARIH}
                      </TableCell>
                      <TableCell align="left" >
                        {row.DURUM}
                      </TableCell>
                      <TableCell align="left" >
                        {row.MALZEME_STOK_NO}
                      </TableCell>
                      <TableCell align="left" >
                        {row.MALZEME_ACIKLAMA}
                      </TableCell>
                      <TableCell align="left" className={classes.tableCell}>
                        <SearchIcon
                          onClick={(event) => { GetMaterialDetailPopup(row.MALZEME_STOK_NO, row.MALZEME_ACIKLAMA); }}
                          color="primary"
                        />

                      </TableCell>
                      <TableCell align="left">
                        {row.ADET}
                      </TableCell>
                      {/* <TableCell align="left">
                        {row.GONDERI_TIP}
                      </TableCell>
                      <TableCell align="left">
                        {row.GONDERI_KODU}
                      </TableCell> */}
                      {/* <TableCell align="left">
                        <AddressSearch
                          setAdres={setAdres}
                          value={{
                            Id: row.WarehouseAddress || '0',
                            Description: row.WarehouseAddressText || 'Adres Seçiniz!...',
                            Materials: row.Malzemeleri | ''
                          } || ''}
                          searchParam={search}
                          MaterialCode={row.MALZEME_STOK_NO}
                          ServicePaperNr={row.FIS_NO}
                          index={index}
                          Adres={row.WarehouseAddress || 0}
                          RowSelected={1}
                          Tip={"Cikis"}
                        />
                      </TableCell>
                      <TableCell align="left">
                        {row.ADRES_ADET}
                      </TableCell> */}

                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={dataPaslasma.length}
              rowsPerPage={pagination.rowsPerPage}
              page={pagination.page}
              onChangePage={(e, v) => setPagination({ ...pagination, page: v })}
              onChangeRowsPerPage={e => setPagination({ page: 0, rowsPerPage: e.target.value })}
            />
          </CardContent>
        </Card>
        <Dialog
          fullWidth
          maxWidth={'xl'}
          open={MaterialDetailPopup}
          onClose={() => setMaterialDetailPopup(false)}
          TransitionComponent={Transition}
          keepMounted
        >
          <DialogTitle id="alert-dialog-title">
            {MaterialHeader} Malzeme Detayı
          </DialogTitle>
          <DialogContent>
            {MaterialCodeParam ? <MaterialDetail MaterialParam={MaterialCodeParam} /> : ""}
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => setMaterialDetailPopup(false)}
              className={classes.button}
              endIcon={<CloseIcon>Close</CloseIcon>}
            >
              Kapat
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
      <Dialog
        open={passEdit}
        onClose={() => setPassEdit(false)}
        keepMounted
        style={{ Width: 500, Height: 500, }}
      >
        <DialogTitle id="alert-dialog-title">
          Gönderi Bilgileri
        </DialogTitle>

        <DialogContent>

          <div className={classes.root}>
            <Typography id="input-slider" gutterBottom>
              Gönderi Tipi
            </Typography>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Select className={classes.input} value={GonderiTipvalue} onChange={handleGonderiTipInputChange}>
                  <option value="1">Yurtiçi Kargo</option>
                  <option value="2">Aras Kargo</option>
                  <option value="3">PTT Kargo</option>
                  <option value="4">Ay Kargo</option>
                  <option value="5">Sürat Kargo</option>
                  <option value="6">Servis Aracı</option>
                  <option value="7">Bölge Aracı</option>
                  <option value="8">Otobüs</option>
                  <option value="9">Özel Araç</option>

                </Select>
              </Grid>
            </Grid>
          </div>
          <Typography id="input-slider" gutterBottom>
            Kargo Takip No
          </Typography>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <Input
                className={classes.input}
                value={KargoNovalue}
                margin="dense"
                onChange={handleKargoNoInputChange}
              />
            </Grid>
          </Grid>

        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => SetGonderimBilgisi()}
            className={classes.button}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Güncelle
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

export default PassOut;
